module.exports = __webpack_public_path__ + "static/media/CoinsC.ef13290b.png";